// extracted by mini-css-extract-plugin
export default {"rightPanel":"rightPanel_rightPanel__nRZ9M","collapsed":"rightPanel_collapsed__OoEqv"};